import { plateFont, numFont } from '../../../utils/fonts';
import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import { LiveDot, TOKENS, hms } from '../../worktime/clock/worktimeLib';
import { useWidgetFrame } from '../frameContext';

const STATE_COLOR = { wo: TOKENS.green, break: TOKENS.amber, day: TOKENS.accent, idle: TOKENS.subtle };

/**
 * Own clock tile (design "Oma kello"): live state row, mono timer, two small actions.
 */
export default function ClockTile({ state = 'idle', stateLabel, seconds = 0, plate, workNumber, buttons = [] }) {
  const frame = useWidgetFrame();
  const edit = frame?.mode === 'edit';
  const color = STATE_COLOR[state] || STATE_COLOR.idle;
  return (
    <Box sx={{ flex: 1, minHeight: 0, p: 2, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, fontSize: 12.5, fontWeight: 600, color }}>
        {state === 'idle' ? <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: color }} /> : <LiveDot color={color} size={8} />}
        <Typography noWrap sx={{ fontSize: 12.5, fontWeight: 600, color }}>
          {stateLabel}
        </Typography>
        {plate ? (
          <Typography sx={{ ml: 'auto', ...plateFont, fontSize: 12, fontWeight: 700, color: TOKENS.navy }}>
            {plate}
            {workNumber ? <Box component="span" sx={{ color: TOKENS.muted, fontWeight: 400, ml: 0.5 }}>#{workNumber}</Box> : null}
          </Typography>
        ) : null}
      </Box>
      <Typography sx={{ ...numFont, fontSize: 30, fontWeight: 700, letterSpacing: '-0.5px', lineHeight: 1.1, color: state === 'idle' ? TOKENS.subtle : TOKENS.fg }}>
        {hms(seconds)}
      </Typography>
      <Box sx={{ display: 'flex', gap: 0.75, mt: 'auto' }}>
        {buttons.map((button) => (
          <Button
            key={button.key || button.label}
            size="small"
            variant={button.variant === 'primary' ? 'contained' : 'outlined'}
            color={button.variant === 'primary' ? 'secondary' : 'inherit'}
            disabled={edit || button.disabled}
            data-testid={button.testId}
            onClick={button.onClick}
            startIcon={button.icon ? <button.icon sx={{ fontSize: 16 }} /> : null}
            sx={{ minWidth: 0, px: 1.25, py: 0.25, fontSize: 12, fontWeight: 600, borderRadius: '8px', ...(button.variant !== 'primary' ? { borderColor: '#e2e8f0', color: button.tone === 'red' ? TOKENS.red : TOKENS.fg } : {}) }}
          >
            {button.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
